import { parse, stringify } from 'querystring'
const createHashQueryManager = hash => {
  const query = parse(hash.substr(1))
  const self = {
    set: (key, value) => {
      if (!key) throw new Error('Missing key')
      if (value) {
        query[key] = value
      } else {
        delete query[key]
      }
      return self
    },
    get: key => {
      if (!key) throw new Error('Missing key')
      return query[key]
    },
    toString: () => (Object.keys(query).length ? '?' + stringify(query) : '')
  }
  return self
}

export default createHashQueryManager
